define([
	'backbone',
	'BaseView'

], function (Backbone, BaseView) {

	'use strict';

	var hasCSSTransition = document.body.style.transition === '';

	var LoadErrorHeaderView = BaseView.extend({
		el: '.js_loadErrorHeader',

		initialize: function () {
			var self = this;

			this.headerContainer = this.$el.find('.js_loadErrorHeaderContainer');

			// changes header from fixed to static to allow error message to be responsive.
			this.$el.parents('body').addClass('loadErrorNavTreatment');

			setTimeout(function () {
				self.showError();
			}, 25025);
		},

		afterRender: function () {
		},

		measureElHeight: function (element, callback) {
			var elHeight;

			// Quickly rendering to DOM to measure height and width.
			// Then, removing it.
			elHeight = element.addClass('showEl').outerHeight();
			element.removeClass('showEl');

			callback(elHeight);
		},

		showError: function () {
			var self = this;

			function finishAnimation () {
				self.headerContainer.removeClass('loadErrorHeaderTransition').
					addClass('autoHeight').
					removeAttr('style');
			}

			this.$el.removeClass('hide');
			this.headerContainer.addClass('loadErrorHeaderTransition');

			this.measureElHeight(this.headerContainer.find('.loadErrorHeaderTable'), function (height) {

				// Wait for the animate class to be added
				setTimeout(function () {
					self.headerContainer.height(height);
				}, 25);

				// Wait for the animation to finish and then
				// removes the classes and style needed for the animation when done
				// Either do this with the transitionend event or setTimeout
				// depending on the browser support
				if (hasCSSTransition) {
					self.headerContainer.one('transitionend', finishAnimation);
				} else {
					setTimeout(finishAnimation, 550); // The time to complete the animation
				}
			});
		}

	});

	return LoadErrorHeaderView;
});


//////////////////
// WEBPACK FOOTER
// ./widgets/loadError-headerMessaging.js
// module id = 876
// module chunks = 0